App.ModifierSchemeRestaurantPrice = DS.Model.extend
  base_price      : DS.attr 'number'

  # Внешние связи
  modifier_scheme : DS.belongsTo 'modifier_scheme',   async: true
  restaurant      : DS.belongsTo 'restaurant', async: true
